module.exports = __webpack_public_path__ + "02_medium_brown.45ac81b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_medium_brown.png
// module id = vK65
// module chunks = 0